namespace Roodik.Core
{
	export class TimeUtility
	{
		public static visualize(seconds : number) : string
		{
			let nMinutes : Number = Math.floor(seconds / 60);
			var nSeconds : Number = Math.floor(seconds % 60);
			if(nSeconds > 9)
			{
				return String(nMinutes) + ":" + String(nSeconds);
			}
			else
			{
				return String(nMinutes) + ":" + ("0" + String(nSeconds));
			}
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Utility/TimeUtility.ts